module.exports = __webpack_public_path__ + "img/symbol_anker.a64cc33.jpg";